export const DECIMAL_PRECISION_UNSTABLE_COIN = 4;
export const DECIMAL_PRECISION_STABLE_COIN = 2;
export const DECIMAL_COEFFICIENT_UNSTABLE_COIN = 10 ** 4;
export const DECIMAL_COEFFICIENT_STABLE_COIN = 10 ** 2;
export const LOAN_ROUNDING_COEFFICIENT = 1000000;
export const LOAN_ROUNDING_PRECISION = 6;
//# sourceMappingURL=rounding.js.map